import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
} from "react";
import {
  get_raw_material_orders,
  get_raw_material_order_details,
  RMProductReturn,
  getInvoiceNumber,
  get_rm_order_returnlist,
  postGeneralData,
  UpdatePaymentComplete,
  ListOrderById,
} from "../../../Utility/Api";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getFormattedCurrentDate2,
  getLocalStorage,
  NaviGate,
  numberToWords,
  AmountInWords,
  onReqCreatePayment,
  setLocalStorage,
  shop_id,
  isReadonlyRoute,
  company_logo,
} from "../../../Utility/function";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { WarehouseContext } from "../../../Utility/UserContext";
import "./customtoogle.css";
import ThermalModal from "./modal/ThermalModal";
import { Pagination } from "../../Common/Functions";
import moment from "moment";

const formatDate = (dateString) => {
  if (!dateString) return "-";
  try {
    const m = moment(dateString);
    if (m.isValid()) {
      return m.format("DD/MM/YYYY");
    }
    const parts = String(dateString).split(/[-/T ]/);
    if (parts.length >= 3 && parts[0].length === 4) {
      return `${parts[2].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[0]}`;
    }
    return dateString;
  } catch (error) {
    return dateString;
  }
};

const RMSalesList = () => {
  const { showLoader, hideLoader, UserItem, shopItem } =
    useContext(WarehouseContext);
  const [user] = useState(UserItem);
  const modalContentRef = useRef(null);
  const componentRef = useRef(null);
  const navigate = useNavigate();
  const ordersPerPage = 10;
  const [Order, setOrder] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState([]);
  const [selectedReturnInvoice, setSelectedReturnInvoice] = useState([]);
  const [Details, setDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [printerType, setPrinterType] = useState("1");
  const [payAmount, setPayAmount] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [uniqueId, setUniqueId] = useState("");
  const [inputUniqueId, setInputUniqueId] = useState("");
  const [resetDone, setResetDone] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [printVisible, setPrintVisible] = useState("");
  const [printOpen, setPrintOpen] = useState(false);
  const [Paymentvalue, setPaymentvalue] = useState();
  const [pamentsModel, setpamentsModel] = useState(false);
  const [isOrderModal, setOrderModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [selectedOrderData, setSelectedOrderData] = useState(null);
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);

  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const [RemarkData, setRemarkData] = useState({ terms: "" });
  const [data, setData] = useState({ bank_name: "", bank_branch: "", account_no: "", shop_title: "" });

  // ── RM Return State ──────────────────────────────────────────
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnOrder, setReturnOrder] = useState(null); // RM SalesMaster row
  const [returnItems, setReturnItems] = useState([]); // RM order line items
  const [returnQtys, setReturnQtys] = useState({}); // { item.id: qty }
  const [returnRefundType, setReturnRefundType] = useState("bank"); // "bank" | "payable"
  const [returnReason, setReturnReason] = useState("");
  const [returnInvoiceNo, setReturnInvoiceNo] = useState("");
  const [globalReturns, setGlobalReturns] = useState([]);
  const [alreadyReturnedQtys, setAlreadyReturnedQtys] = useState({});

  const [companyInfo, setCompanyInfo] = useState({
    name: "Company Name",
    address: "123 Business Street, City, State 12345",
    phone: "(123) 456-7890",
    email: "info@yourcompany.com",
  });

  const getOrderReturnedAmount = (orderId, orderMasterId) => {
    let totalReturned = 0;
    globalReturns.forEach((ret) => {
      let retData = [];
      try {
        if (ret.return_data) {
          retData = JSON.parse(ret.return_data);
        } else if (ret.invoice_number) {
          retData = JSON.parse(ret.invoice_number);
        }
      } catch (e) {}

      if (Array.isArray(retData)) {
        retData.forEach((retItem) => {
          const isMatch =
            retItem.om_id == orderMasterId ||
            retItem.unique_id === orderId ||
            (ret.unique_id && ret.unique_id.includes(orderId));

          if (isMatch) {
            const qty = parseFloat(retItem.returnqty || retItem.qty || 0);
            const price = parseFloat(retItem.price || 0);
            const amt = parseFloat(retItem.amount || qty * price || 0);
            totalReturned += amt;
          }
        });
      }
    });
    return totalReturned;
  };

  const getUnitPrice = (it) => {
    return parseFloat(it.price || 0);
  };

  useEffect(() => {
    if (shopItem) {
      setCompanyInfo({
        name: shopItem?.title || "",
        address: shopItem?.Address || "123 Business Street, City, State 12345",
        phone: shopItem?.phone1 || "",
        email: shopItem?.email || "",
      });
      setData({
        bank_name: shopItem?.bank_name || "N/A",
        bank_branch: shopItem?.bank_branch || "N/A",
        account_no: shopItem?.account_no || "N/A",
        shop_title: shopItem?.title || "N/A",
      });
      setRemarkData({
        terms: shopItem?.terms || "",
      });
    }
  }, [shopItem]);

  useEffect(() => {
    try {
      var value = getLocalStorage("PrinterType");
      if (value) {
        setPrinterType(value);
      } else {
        setPrinterType("0");
      }
    } catch (error) {
      setPrinterType("0");
    }
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setUniqueId(inputUniqueId);
    }, 1000); // Debounce search
    return () => clearTimeout(delayDebounce);
  }, [inputUniqueId]);

  useEffect(() => {
    if (resetDone) {
      fetchOrders(1);
      setResetDone(false);
    }
  }, [resetDone]);

  const Handlepaymentmodel = async (item) => {
    setPayAmount(0);
    setCashAmount(0);
    setCardAmount(0);
    setPaymentvalue(item);
    setpamentsModel(true);
  };

  const onHandlePayCredit = async (cashAmount, cardAmount) => {
    try {
      showLoader();
      if (!Paymentvalue?.id) {
        toast.error("Invalid order details");
        hideLoader();
        return;
      }

      const cash = parseFloat(cashAmount || 0);
      const card = parseFloat(cardAmount || 0);
      var paydata = {
        orderID: Paymentvalue?.order_id,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: Paymentvalue.overall_price,
        cash: cash,
        credit: 0,
        card: card,
        type: 2,
        mop: "0",
        complete: "1",
      };

      if (cashAmount && cardAmount) {
        paydata.cash = cashAmount;
        paydata.card = cardAmount;
        paydata.mop = "1,4";
      } else if (cashAmount) {
        paydata.cash = cashAmount;
        paydata.mop = "1";
      } else if (cardAmount) {
        paydata.card = cardAmount;
        paydata.mop = "4";
      }

      if (remainingAmount > 0) {
        paydata.credit = remainingAmount;
        paydata.mop = paydata.mop + ",2";
        paydata.complete = "0";
      }

      await onReqCreatePayment(paydata);

      try {
        const generalDataPayload1 = {
          type: "2",
          ref_id: Paymentvalue?.order_id,
          remarks: "Bank - From RM sales",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0),
          is_debit: "1",
        };
        await postGeneralData(generalDataPayload1);

        if (paydata?.complete == "0") {
          const generalDataPayload = {
            type: "8",
            ref_id: Paymentvalue?.order_id,
            remarks: "RM Sales Credit",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: remainingAmount,
            is_debit: "1",
            profitloss: "",
          };
          await postGeneralData(generalDataPayload);
        } else {
          const paymentCompleted = {
            type: "8",
            shop_id: shopItem?.id || "0",
            ref_id: Paymentvalue?.order_id,
          };
          await UpdatePaymentComplete(paymentCompleted);
        }
      } catch (e) {
        console.error("General log failed:", e);
        toast.error("Failed to create general transaction log");
      }

      toast.success("Payment successfully");
      await fetchOrders();
      setpamentsModel(false);
      setCurrentPage(1);
      setPayAmount(0);
      setCashAmount(0);
      setCardAmount(0);
      hideLoader();
    } catch (error) {
      console.error("Error updating payment:", error);
      toast.error("Error processing payment. Please try again.");
      hideLoader();
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [uniqueId]);

  const fetchOrders = useCallback(
    async (pages = 1) => {
      try {
        showLoader();
        const filters = {
          shop_id: shopItem?.shop_id || "",
          status: "4", // completed
        };

        const [response, returnsRes] = await Promise.all([
          get_raw_material_orders(filters),
          get_rm_order_returnlist().catch((e) => {
            console.error("Error fetching returns list:", e);
            return { data: { data: [] } };
          }),
        ]);

        if (response.data && response.data.data) {
          // Filter by unique_id client-side if searched
          let filtered = response.data.data;
          if (uniqueId) {
            filtered = filtered.filter(
              (o) =>
                o.order_id?.toLowerCase().includes(uniqueId.toLowerCase()) ||
                o.customer_name?.toLowerCase().includes(uniqueId.toLowerCase())
            );
          }
          setOrder(filtered);
          setTotalPages(Math.ceil(filtered.length / ordersPerPage));
        }

        if (returnsRes.data && returnsRes.data.data) {
          setGlobalReturns(returnsRes.data.data);
        }
        hideLoader();
      } catch (error) {
        console.error("Error fetching order data:", error);
        hideLoader();
      }
    },
    [uniqueId, shopItem]
  );

  const handleFilter = (e) => {
    e.preventDefault();
    fetchOrders();
  };

  const resetFilter = () => {
    setFromDate("");
    setToDate("");
    setUniqueId("");
    setInputUniqueId("");
    setResetDone(true);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handleGetpayment = async (state) => {
    try {
      showLoader();
      setOrderModal(true);
      setSelectedOrder([]);
      setOrderItems([]);
      setSelectedOrderData(state);
      const [paymentRes, itemsRes] = await Promise.all([
        ListOrderById(state.order_id),
        get_raw_material_order_details({ om_id: state.id })
      ]);
      if (paymentRes.data && paymentRes.data.payment) {
        setSelectedOrder(paymentRes.data.payment);
      } else {
        setSelectedOrder([]);
      }
      if (itemsRes.data && itemsRes.data.data) {
        setOrderItems(itemsRes.data.data);
      } else {
        setOrderItems([]);
      }
      hideLoader();
    } catch (error) {
      hideLoader();
      setSelectedOrder([]);
      setOrderItems([]);
      console.error("Error fetching order details:", error);
    }
  };

  const handleGet = async (state) => {
    try {
      showLoader();
      setDetails({
        ...state,
        unique_id: state.order_id,
        date: state.create_date?.split("T")[0],
        total: state.overall_price,
        vat: state.tax_percent || "0",
        discount: state.discount || "0",
        purchase_unit: state.payments_status !== "2" ? "2" : "1"
      });

      const res = await get_raw_material_order_details({ om_id: state.id });
      if (res?.data && res?.data?.status === "success") {
        const formatted = res.data.data.map(item => ({
          ...item,
          product_name: item.raw_material_title,
          sales_price: item.price,
          amount_per_price: item.p_price,
          discount: "0",
          discount_type: "0",
          serial_number: "[]"
        }));
        setSelectedInvoice(formatted);
      } else {
        setSelectedInvoice([]);
      }

      // Filter global returns for this order
      const relatedReturns = globalReturns.filter(ret => {
        let retData = [];
        try {
          if (ret.return_data) retData = JSON.parse(ret.return_data);
        } catch (e) {}
        return retData.some(it => it.om_id == state.id);
      });

      const formattedReturns = relatedReturns.flatMap(ret => {
        let retData = [];
        try {
          if (ret.return_data) retData = JSON.parse(ret.return_data);
        } catch (e) {}
        return retData.map(it => ({
          product_name: it.product_name || `RM #${it.raw_mat_id}`,
          qty: it.returnqty || it.qty || 0,
          sales_price: it.price || 0,
          amount_per_price: it.amount || 0,
          returnAmount: it.amount || 0
        }));
      });

      setSelectedReturnInvoice(formattedReturns);
      setShowModal(true);
      hideLoader();
    } catch (error) {
      hideLoader();
      console.error("Error fetching order details:", error);
      toast.error("Failed to load details");
    }
  };

  const handlePrint = async () => {
    setPrintVisible("d-none");
    setTimeout(async () => {
      const content = modalContentRef.current;
      if (!content) {
        console.error("Modal content not found for printing");
        return;
      }

      try {
        const canvas = await html2canvas(content, { scale: 3 });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = 200;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        const xOffset = (pdfWidth - imgWidth) / 2;
        const yOffset = (pdfHeight - imgHeight) / 2;

        pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const printWindow = window.open(pdfUrl, "_blank");

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print();
          };
        }
        URL.revokeObjectURL(pdfUrl);
        setTimeout(() => {
          setPrintVisible("");
        }, 1000);
      } catch (error) {
        setPrintVisible("");
        console.error("Failed to generate or print PDF:", error);
      }
    }, 10);
  };

  const handlePrint1 = async () => {
    const content = componentRef.current;
    if (!content) return;
    try {
      const canvas = await html2canvas(content, { scale: 3 });
      const imgData = canvas.toDataURL("image/png");
      const contentHeightMm = (canvas.height * 80) / canvas.width;

      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [80, contentHeightMm],
      });

      pdf.addImage(imgData, "PNG", 1, 5, 78, contentHeightMm, undefined, "FAST");
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const printWindow = window.open(pdfUrl, "_blank");
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error("Error generating receipt PDF:", error);
    }
  };

  const handleSelectPrinter = (type) => {
    setLocalStorage("PrinterType", type);
    setPrinterType(type);
    setPrintOpen(false);
  };

  const [cashAmount, setCashAmount] = useState("");
  const [cardAmount, setCardAmount] = useState("");

  const dueAmount = parseFloat(Paymentvalue?.remaining || 0);
  const totalPayment =
    parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0);
  const remainingAmount = dueAmount - totalPayment;

  const handleCashChange = (e) => {
    let value = e.target.value;
    if (value === "") {
      setCashAmount("");
      return;
    }
    if (!/^\d*(\.\d*)?$/.test(value)) return;
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue + parseFloat(cardAmount || 0) > dueAmount) return;
    setCashAmount(value);
  };

  const handleCardChange = (e) => {
    let value = e.target.value;
    if (value === "") {
      setCardAmount("");
      return;
    }
    if (!/^\d*(\.\d*)?$/.test(value)) return;
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue + parseFloat(cashAmount || 0) > dueAmount) return;
    setCardAmount(value);
  };

  const handleToggle = () => {
    if (printerType == "0") {
      handleSelectPrinter("1");
    } else {
      handleSelectPrinter("0");
    }
  };

  // ── RM Return Handlers ────────────────────────────────────────
  const handleOpenReturn = async (order) => {
    try {
      showLoader();
      setReturnOrder(order);
      setReturnQtys({});
      setReturnReason("");
      setReturnRefundType("bank");

      // Fetch invoice number for the return
      const invRes = await getInvoiceNumber(4);
      if (invRes.data?.invoice_no) setReturnInvoiceNo(invRes.data.invoice_no);

      // Fetch order details
      const itemsRes = await get_raw_material_order_details({ om_id: order.id });
      const items = itemsRes?.data?.data || [];
      setReturnItems(items);

      // Calculate already returned quantities
      const returnedCounts = {};
      items.forEach((it) => {
        let totalReturned = 0;
        globalReturns.forEach((ret) => {
          let retData = [];
          try {
            if (ret.return_data) {
              retData = JSON.parse(ret.return_data);
            } else if (ret.invoice_number) {
              retData = JSON.parse(ret.invoice_number);
            }
          } catch (e) {}

          if (Array.isArray(retData)) {
            retData.forEach((retItem) => {
              const isMatch =
                retItem.id == it.id ||
                (retItem.raw_mat_id == it.raw_mat_id &&
                  (retItem.unique_id === order.order_id ||
                    (ret.unique_id && ret.unique_id.includes(order.order_id))));

              if (isMatch) {
                totalReturned += parseFloat(retItem.returnqty || retItem.qty || 0);
              }
            });
          }
        });
        returnedCounts[it.id] = totalReturned;
      });
      setAlreadyReturnedQtys(returnedCounts);

      // Pre-fill qty = 0
      const initial = {};
      items.forEach((it) => {
        initial[it.id] = 0;
      });
      setReturnQtys(initial);

      setShowReturnModal(true);
    } catch (err) {
      console.error("Error opening return:", err);
      toast.error("Failed to load order items");
    } finally {
      hideLoader();
    }
  };

  const handleReturnQtyChange = (itemId, value, maxQty) => {
    let v = parseFloat(value);
    if (isNaN(v) || v < 0) v = 0;
    if (v > maxQty) v = maxQty;
    // Format to 2 decimal places to avoid floating point representation issues
    setReturnQtys((prev) => ({ ...prev, [itemId]: parseFloat(v.toFixed(2)) }));
  };

  const calcReturnFinancials = () => {
    let totalReturn = 0;
    returnItems.forEach((it) => {
      const qty = returnQtys[it.id] || 0;
      const unitPrice = getUnitPrice(it);
      totalReturn += qty * unitPrice;
    });

    const returnedAmt = getOrderReturnedAmount(
      returnOrder?.order_id,
      returnOrder?.id
    );
    const creditBalance = Math.max(
      0,
      parseFloat(returnOrder?.remaining || 0) - returnedAmt
    );

    const creditAdjust = Math.min(totalReturn, creditBalance);
    const refundAmount = Math.max(0, totalReturn - creditAdjust);
    const newCredit = Math.max(0, creditBalance - creditAdjust);

    return { totalReturn, creditAdjust, refundAmount, newCredit };
  };

  const handleProcessReturn = async () => {
    const selectedItems = returnItems.filter((it) => (returnQtys[it.id] || 0) > 0);
    if (selectedItems.length === 0) {
      toast.error("Please select at least one item to return");
      return;
    }

    try {
      showLoader();
      const fin = calcReturnFinancials();
      const shopId = shopItem?.id || shopItem?.shop_id || "0";

      const returnPayloads = selectedItems.map((it) => {
        const qty = returnQtys[it.id];
        const unitPrice = getUnitPrice(it);
        const returnAmt = qty * unitPrice;
        return {
          id: it.id,
          om_id: it.om_id,
          raw_mat_id: it.raw_mat_id,
          returnqty: qty,
          return_serial_number: "[]",
          serial_number: "[]",
          unique_id: it.order_id || returnOrder?.order_id,
          customer_name: returnOrder?.customer_name,
          user_id: user?.user_id,
          shop_id: shopId,
          amount: returnAmt.toFixed(2),
          credit_adjustment: "0",
        };
      });

      await RMProductReturn({
        serial_number: JSON.stringify([]),
        invoice_number: JSON.stringify(
          selectedItems.map((it) => {
            const unitPrice = getUnitPrice(it);
            return {
              unique_id: it.order_id || returnOrder?.order_id,
              product_name: it.raw_material_title || `RM #${it.raw_mat_id}`,
              qty: returnQtys[it.id],
              price: unitPrice.toFixed(2),
            };
          })
        ),
        amount: fin.refundAmount.toFixed(2),
        credit_adjustment: fin.creditAdjust.toFixed(2),
        remaining: returnRefundType === "payable" ? fin.refundAmount.toFixed(2) : "0",
        sales_update: JSON.stringify(
          selectedItems.map((it) => ({
            id: it.id,
            return_qty: returnQtys[it.id],
          }))
        ),
        unique_id: returnInvoiceNo,
        user_id: user?.user_id || "",
        shop_id: shopId,
        type: "rm",
        return_data: JSON.stringify(returnPayloads),
        status: returnRefundType === "payable" ? 1 : 0,
        returnqty: selectedItems.reduce((s, it) => s + (returnQtys[it.id] || 0), 0),
        remarks: returnReason || `RM Sales Return - ${returnOrder?.order_id}`,
      });

      toast.success("RM Sales Return created successfully");
      setShowReturnModal(false);
      fetchOrders();
    } catch (err) {
      console.error("RM Return failed:", err);
      toast.error(err?.response?.data?.message || "RM Return failed");
    } finally {
      hideLoader();
    }
  };

  const paginatedOrders = Order.slice(
    (currentPage - 1) * ordersPerPage,
    currentPage * ordersPerPage
  );

  const paidAmount = selectedOrder
    ?.filter((item) => item.mop != "2")
    ?.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded-2xl border border-slate-100 shadow-sm">
          <div className="text-start">
            <h3 className="mb-1 fw-bold text-slate-800 tracking-tight" style={{ fontSize: "24px" }}>
              RM Sales List
            </h3>
            <p className="text-sm text-slate-500 mb-0 font-medium">Record and manage customer RM sales invoices</p>
          </div>
        </div>

        {/* Filters Section */}
        <form onSubmit={handleFilter} className="row g-3 mb-3 d-none">
          <div className="col-md-2">
            <label>From Date:</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="col-md-2 align-items-end">
            <label>To Date:</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <label>Unique ID:</label>
            <input
              type="text"
              className="form-control"
              value={inputUniqueId}
              onChange={(e) => setInputUniqueId(e.target.value)}
            />
          </div>
          <div className="col-6 col-md-2 mb-2 mb-md-0 d-flex flex-column align-items-end gap-1 ms-auto">
            <button
              type="submit"
              className="btn btn-primary btn-sm px-2 py-1 w-auto"
              style={{ fontSize: "0.75rem", minWidth: "100px" }}
            >
              Filter
            </button>
            <button
              type="button"
              onClick={resetFilter}
              className="btn btn-secondary btn-sm px-2 py-1 w-auto"
              style={{ fontSize: "0.75rem", minWidth: "100px" }}
            >
              Reset
            </button>
          </div>
        </form>

        {/* RM Sales Table */}
        <div className="card border-0 shadow-sm rounded-2xl">
          <div className="card-body p-4">
            <div className="table-responsive">
              <table
                className="table table-hover table-align-middle text-center mb-4"
                style={{ width: "100%", fontFamily: "Poppins" }}
              >
                <thead className="table-light">
                  <tr>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">#</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Unique ID</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Customer</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Total Price (INR)</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Action</th>
                    {!readonly && <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider"></th>}
                  </tr>
                </thead>
                <tbody>
                  {paginatedOrders.map((item, index) => (
                    <tr key={index} className="align-middle border-bottom border-slate-100">
                      <td className="text-sm font-semibold text-slate-700 py-3">
                        {(currentPage - 1) * ordersPerPage + index + 1}
                      </td>
                      <td className="text-sm font-semibold text-slate-700">{item.order_id}</td>
                      <td className="text-sm text-slate-600" style={{ maxWidth: "200px", whiteSpace: "normal", overflowWrap: "break-word" }}>{item.customer_name}</td>
                      <td className="text-sm text-slate-600">
                        {formatDate(item.create_date || item.date_time)}
                      </td>
                      <td className="text-sm font-semibold text-slate-700">{item.overall_price}</td>
                      <td className="text-sm text-slate-600">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          <img
                            src="/assets/images/icons/view.png"
                            onClick={() => handleGetpayment(item)}
                            style={{ height: "16px", cursor: "pointer" }}
                            alt="View"
                          />
                          {!readonly && (
                            <button
                              className="btn btn-danger btn-sm py-0.5 px-2"
                              style={{ fontSize: "11px", borderRadius: "4px" }}
                              onClick={() => handleOpenReturn(item)}
                              title="Process Return"
                            >
                              Return
                            </button>
                          )}
                        </div>
                      </td>
                      {!readonly && (() => {
                        const returnedAmt = getOrderReturnedAmount(item.order_id, item.id);
                        const remainingBal = Math.max(0, parseFloat(item?.remaining || 0) - returnedAmt);
                        return (
                          <td className="text-sm text-slate-600">
                            <div className="d-flex justify-content-center">
                              {item?.payments_status !== "2" && remainingBal > 0 ? (
                                <button
                                  className="btn btn-warning btn-sm w-50"
                                  onClick={() => {
                                    Handlepaymentmodel({ ...item, remaining: remainingBal });
                                  }}
                                >
                                  Pay
                                </button>
                              ) : (
                                <button className="btn btn-success btn-sm w-50" disabled>
                                  {returnedAmt > 0 && remainingBal === 0 ? "Returned" : "Paid"}
                                </button>
                              )}
                            </div>
                          </td>
                        );
                      })()}
                    </tr>
                  ))}
                </tbody>
              </table>

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>

        {/* View Details / Invoice Modal */}
        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          tabIndex={-1}
          role="dialog"
          style={{ display: showModal ? "block" : "none" }}
          aria-hidden={!showModal}
        >
          <div className={`modal-dialog ${printerType == "1" ? "modal-sm" : "modal-lg"}`} role="document">
            <div className="modal-content" ref={modalContentRef}>
              <div className="modal-header border-0 pb-0 mb-1">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              {printerType == "1" && (
                <ThermalModal
                  ref={componentRef}
                  InvoiceDetail={Details}
                  Products={selectedInvoice}
                  ReturnItem={selectedReturnInvoice}
                  Payment={selectedOrder}
                  paidAmount={paidAmount}
                  companyInfo={companyInfo}
                />
              )}

              {printerType == "0" && (
                <>
                  <div className="d-flex justify-content-end mt-2 mx-4">
                    <div className="form-check form-check-inline mx-1">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="language"
                        id="english"
                        value="english"
                        checked={selectedLanguage === "english"}
                        onChange={() => setSelectedLanguage("english")}
                      />
                      <label className="form-check-label" htmlFor="english">
                        English
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="language"
                        id="arabic"
                        value="arabic"
                        checked={selectedLanguage === "arabic"}
                        onChange={() => setSelectedLanguage("arabic")}
                      />
                      <label className="form-check-label" htmlFor="arabic">
                        العربية
                      </label>
                    </div>
                  </div>

                  <div className="row mx-3 mt-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="col-md-1">
                        <img
                          src={company_logo || "/assets/images/ztr_masala_logo.jpg"}
                          alt="Left Logo"
                          style={{ maxHeight: "38px" }}
                        />
                      </div>
                    </div>
                    <div className="col-12 text-center">
                      <p className="fw-bold font-14 mb-0">{companyInfo?.address}</p>
                      <p className="fw-medium font-13 mb-0">
                        Mobile: {companyInfo?.phone} | Email: {companyInfo?.email}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col text-center">
                      <h3 className="fw-bold mt-2" style={{ textDecoration: "underline" }}></h3>
                      <h3 className="fw-bold">
                        {selectedLanguage === "arabic" ? "فاتورة" : "Invoice"}
                      </h3>
                    </div>
                  </div>

                  <div className="row border-top border-bottom pt-3 mx-3 pb-2">
                    <div className="col-6 text-start">
                      <div
                        className="p-2"
                        style={{
                          border: ".8px solid #dee2e6",
                          minHeight: 150,
                        }}
                      >
                        <h6 className="fw-bold">
                          {selectedLanguage === "arabic" ? "تفاصيل العميل:" : "Customer Details:"}
                        </h6>
                        <div className="d-flex justify-content-between">
                          <p className="fw-semibold font-13 mb-1">
                            {selectedLanguage === "arabic" ? "الاسم:" : "Name:"}
                          </p>
                          <p className="fw-bold font-13 mb-1">{Details?.customer_name}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p className="fw-semibold font-13 mb-1">
                            {selectedLanguage === "arabic" ? "البريد الإلكتروني:" : "Email:"}
                          </p>
                          <p className="fw-bold font-13 mb-1">{Details?.customer_email}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p className="fw-semibold font-13 mb-1">
                            {selectedLanguage === "arabic" ? "العنوان:" : "Address:"}
                          </p>
                          <p className="fw-bold font-13 mb-1">{Details?.additional_details}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p className="fw-semibold font-13 mb-1">
                            {selectedLanguage === "arabic" ? "الهاتف:" : "Phone:"}
                          </p>
                          <p className="fw-bold font-13 mb-1">{Details?.customer_phone}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 text-start">
                      <table className="table table-bordered text-center align-middle m-0">
                        <tbody>
                          <tr className="hight-header">
                            <td className="text-start fw-bold">
                              {selectedLanguage === "arabic" ? "رقم الفاتورة:" : "Inv No:"}{" "}
                              {Details.order_id}
                            </td>
                            <td className="text-start fw-bold">
                              {selectedLanguage === "arabic" ? "التاريخ:" : "Date:"}{" "}
                              {formatDate(Details.create_date || Details.date_time)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="table table-bordered text-center align-middle">
                        <tbody>
                          <tr>
                            <td className="text-start d-flex flex-row">
                              <p className="fw-bold text-start mb-0" style={{ width: "40%" }}>
                                {selectedLanguage === "arabic" ? "رقم الطلب:" : "L.P.O No:"}
                              </p>
                              <p className="text-start mb-0 fw-semibold" style={{ width: "60%" }}>
                                {Details?.lpo_no}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-start d-flex flex-row">
                              <p className="fw-bold text-start mb-0" style={{ width: "40%" }}>
                                {selectedLanguage === "arabic" ? "البائع:" : "Sales Person:"}
                              </p>
                              <p className="text-start mb-0 fw-semibold" style={{ width: "60%" }}>
                                {Details?.user_name}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row mt-4 mx-4">
                    <div
                      className="col-md-12"
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 90%), rgba(255, 255, 255, 90%)), url(/assets/images/ztr_masala_logo.jpg) no-repeat center center / cover`,
                        backgroundSize: "60%",
                        backgroundPosition: "center",
                      }}
                    >
                      <div className="table-responsive">
                        <table className="border table-sm table-bordered w-100">
                          <thead className="table-light">
                            <tr className="bg-transparent">
                              <th className="bg-transparent">
                                <span>{selectedLanguage === "arabic" ? "الرقم" : "SL No."}</span>
                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === "arabic" ? "التفاصيل" : "Particulars"}</span>
                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === "arabic" ? "الكمية" : "Pkg Qty"}</span>
                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === "arabic" ? "سعر الوحدة" : "Unit Price"}</span>
                              </th>
                              <th className="bg-transparent">
                                <span>{selectedLanguage === "arabic" ? "الخصم" : "Offer"}</span>
                              </th>
                              <th className="bg-transparent" colSpan={2}>
                                <span>{selectedLanguage === "arabic" ? "المبلغ الإجمالي" : "Total Amount"}</span>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {Array.isArray(selectedInvoice) &&
                              selectedInvoice.map((item, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <tr className="bg-transparent">
                                      <td className="bg-transparent">{index + 1}</td>
                                      <td
                                        className="fw-semibold"
                                        style={{
                                          whiteSpace: "normal",
                                          maxWidth: "240px",
                                        }}
                                      >
                                        {item.product_name}
                                      </td>
                                      <td className="fw-semibold">{item.qty}</td>
                                      <td className="fw-semibold">
                                        {(parseFloat(item.p_price) / parseFloat(item.qty)).toFixed(2)}
                                      </td>
                                      <td className="fw-semibold">Normal sale</td>
                                      <td className="fw-semibold" colSpan={2}>
                                        {Number(item.p_price).toFixed(2)}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            {selectedReturnInvoice?.length > 0 && (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  <strong>
                                    {selectedLanguage === "arabic" ? "إرجاع المنتجات" : "Return Products"}
                                  </strong>
                                </td>
                              </tr>
                            )}
                            {Array.isArray(selectedReturnInvoice) &&
                              selectedReturnInvoice.map((item, index) => (
                                <tr key={`additional-product-${index}`}>
                                  <td className="text-semibold">{index + 1}</td>
                                  <td className="text-semibold">{item?.product_name || "N/A"}</td>
                                  <td className="text-semibold">{item?.qty || "0"}</td>
                                  <td className="text-semibold">{item?.sales_price}</td>
                                  <td className="text-semibold">Normal sale</td>
                                  <td colSpan={2}>{"- " + item?.returnAmount}</td>
                                </tr>
                              ))}
                          </tbody>

                          <tfoot>
                            <tr>
                              <br />
                            </tr>

                            <tr>
                              <td className="bg-transparent fw-bold text-end" colSpan={5}>
                                {selectedLanguage === "arabic" ? "الإجمالي" : "Total"}
                              </td>
                              <td className="bg-transparent fw-semibold" colSpan={2}>
                                {selectedInvoice
                                  ?.reduce((acc, item) => acc + (parseFloat(item?.p_price) || 0), 0)
                                  .toFixed(2)}
                              </td>
                            </tr>

                            {Details.purchase_unit != 1 && (
                              <tr>
                                <td colSpan={5} className="text-center fw-semibold">
                                  Payment History
                                </td>
                              </tr>
                            )}

                            {Details.purchase_unit != 1 &&
                              selectedOrder
                                ?.filter((item) => item.mop != "2")
                                ?.map((item, index) => (
                                  <tr key={index}>
                                    <td colSpan={4} className="text-end fw-bold px-2">
                                      {formatDate(item.date)}
                                    </td>
                                    <td colSpan={1} className="text-end fw-bold px-2">
                                      {item.mop == "1" ? "Cash" : item.mop == "4" ? "Card" : ""}
                                    </td>
                                    <td colSpan={2} className="text-center fw-semibold">
                                      {parseFloat(item.amount || 0).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}

                            {Details.purchase_unit != 1 && (
                              <tr>
                                <td colSpan={5} className="text-end fw-bold px-2">
                                  {"Remaining Balance"}
                                </td>
                                <td colSpan={2} className="text-center text-danger fw-semibold">
                                  {(
                                    parseFloat(Details?.overall_price || 0) - parseFloat(paidAmount || 0)
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            )}

                            <tr>
                              <td colSpan={7} className="text-start text-wrap">
                                <p className="my-2">
                                  <strong>
                                    {selectedLanguage === "arabic" ? "المبلغ بالأحرف:" : "Amount In Words:"}
                                    &nbsp;
                                    {AmountInWords(Details?.overall_price)}
                                  </strong>
                                </p>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="row border-top border-bottom py-3 mx-3 text-start">
                    <div className="col-10 col-md-4 d-flex">
                      <div className="p-2 flex-fill d-flex flex-column" style={{ border: ".8px solid #dee2e6" }}>
                        <h6 className="fw-bold">
                          {selectedLanguage === "arabic" ? "الشروط والأحكام" : "Terms & Condition:"}
                        </h6>
                        <p className="mt-2 fs-8 flex-grow-1" style={{ whiteSpace: "pre-wrap" }}>
                          {RemarkData?.terms}
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-md-4 d-flex">
                      <div className="p-2 flex-fill d-flex flex-column" style={{ border: ".8px solid #dee2e6" }}>
                        <h6 className="fw-bold">
                          {selectedLanguage === "arabic" ? "حساب البنك" : "Bank Account:"}
                        </h6>
                        <p className="mt-2 fs-6 flex-grow-1">
                          Name:{data?.bank_name || "N/A"}
                          <br />
                          Bank:{data?.bank_branch || "N/A"}
                          <br />
                          {data?.account_no ? `A/C No: ${data.account_no}` : "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-md-4 d-flex">
                      <div className="p-2 flex-fill d-flex flex-column" style={{ border: ".8px solid #dee2e6" }}>
                        <h6 className="fw-bold">
                          {selectedLanguage === "arabic" ? "الشركة" : "For Company:"}
                        </h6>
                        <p className="mt-2 fs-6 flex-grow-1">{data?.shop_title || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="modal-footer mx-1 mt-4">
                <div className="form-check form-switch d-flex align-items-center gap-2 me-auto">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={printerType == "1"}
                    onChange={handleToggle}
                  />
                  <label className="form-check-label text-slate-600 font-semibold text-xs mb-0">
                    Thermal Printer Mode
                  </label>
                </div>
                <button
                  type="button"
                  className={"btn btn-info " + printVisible}
                  onClick={() => {
                    printerType == "0" ? handlePrint() : handlePrint1();
                  }}
                >
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ── RM RETURN MODAL ────────────────────────────────────── */}
        {showReturnModal && (() => {
          const fin = calcReturnFinancials();
          return (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div
                  className="modal-content"
                  style={{ borderRadius: "14px", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}
                >
                  {/* Header */}
                  <div
                    className="modal-header"
                    style={{
                      background: "linear-gradient(135deg, #dc3545 0%, #b02a37 100%)",
                      borderRadius: "14px 14px 0 0",
                    }}
                  >
                    <div>
                      <h5 className="modal-title text-white fw-bold mb-0">🔄 Process RM Sales Return</h5>
                      <small className="text-white opacity-75">
                        Order: {returnOrder?.order_id} &nbsp;|&nbsp; Customer: {returnOrder?.customer_name}
                      </small>
                    </div>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={() => setShowReturnModal(false)}
                    ></button>
                  </div>

                  {/* Body */}
                  <div className="modal-body text-start p-4">
                    {/* Order Items Table */}
                    <h6 className="fw-bold mb-3 text-dark">Select Items to Return</h6>
                    {returnItems.length === 0 ? (
                      <div className="text-center text-muted py-4">No items found for this order.</div>
                    ) : (
                      <div className="table-responsive mb-4">
                        <table className="table table-bordered table-sm align-middle text-center">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Raw Material</th>
                              <th>Sold Qty</th>
                              <th className="text-danger">Returned Qty</th>
                              <th>Unit Price</th>
                              <th>Return Qty</th>
                              <th className="text-end">Return Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {returnItems.map((it, idx) => {
                              const alreadyRet = alreadyReturnedQtys[it.id] || 0;
                              const soldQty = parseFloat(it.qty || 0) + alreadyRet;
                              const remainingQty = parseFloat(it.qty || 0);
                              const retQty = returnQtys[it.id] || 0;
                              const unitPrice = getUnitPrice(it);
                              const retAmt = retQty * unitPrice;
                              return (
                                <tr key={it.id} className={retQty > 0 ? "table-danger" : ""}>
                                  <td>{idx + 1}</td>
                                  <td className="text-start">
                                    <div className="fw-semibold">{it.raw_material_title || `RM #${it.raw_mat_id}`}</div>
                                    {it.batch_no && <small className="text-muted">Batch: {it.batch_no}</small>}
                                  </td>
                                  <td>{soldQty}</td>
                                  <td className="text-danger fw-semibold">{alreadyRet > 0 ? alreadyRet : "—"}</td>
                                  <td>₹{unitPrice.toFixed(2)}</td>
                                  <td style={{ width: "130px" }}>
                                    {remainingQty <= 0 ? (
                                      <span className="badge bg-danger">Fully Returned</span>
                                    ) : (
                                      <div className="d-flex align-items-center gap-1 justify-content-center">
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary btn-sm px-2 py-0"
                                          onClick={() =>
                                            handleReturnQtyChange(it.id, (retQty - 1).toString(), remainingQty)
                                          }
                                        >
                                          -
                                        </button>
                                        <input
                                          type="number"
                                          step="any"
                                          className="form-control form-control-sm qty-input-no-spin text-center"
                                          value={retQty}
                                          min={0}
                                          max={remainingQty}
                                          onChange={(e) => handleReturnQtyChange(it.id, e.target.value, remainingQty)}
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary btn-sm px-2 py-0"
                                          onClick={() =>
                                            handleReturnQtyChange(it.id, (retQty + 1).toString(), remainingQty)
                                          }
                                        >
                                          +
                                        </button>
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-end fw-semibold">
                                    {retQty > 0 ? `₹${retAmt.toFixed(2)}` : "—"}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Financial Summary */}
                    <div className="card border-0 mb-3" style={{ background: "#f8f9fa" }}>
                      <div className="card-body p-3">
                        <h6 className="fw-bold mb-3" style={{ color: "#dc3545" }}>
                          Financial Summary
                        </h6>
                        <div className="row g-2">
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Total Return Value</span>
                              <span className="fw-bold">₹{fin.totalReturn.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Customer Credit Balance</span>
                              <span className="fw-bold text-info">
                                ₹
                                {Math.max(
                                  0,
                                  parseFloat(returnOrder?.remaining || 0) -
                                    getOrderReturnedAmount(returnOrder?.order_id, returnOrder?.id)
                                ).toFixed(2)}
                              </span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Credit Adjusted</span>
                              <span className="fw-bold text-warning">−₹{fin.creditAdjust.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Refund Amount</span>
                              <span className="fw-bold text-success">₹{fin.refundAmount.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between">
                              <span className="text-muted small">New Credit Balance</span>
                              <span className="fw-bold text-primary">₹{fin.newCredit.toFixed(2)}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Refund Type Toggle */}
                    {fin.refundAmount > 0 && (
                      <div className="mb-3">
                        <label className="fw-semibold mb-2 d-block">
                          How to handle ₹{fin.refundAmount.toFixed(2)} refund?
                        </label>
                        <div className="d-flex gap-3">
                          <div
                            className={`flex-fill p-3 rounded border-2 cursor-pointer ${
                              returnRefundType === "bank" ? "border border-danger bg-danger bg-opacity-10" : "border"
                            }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setReturnRefundType("bank")}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <input
                                type="radio"
                                checked={returnRefundType === "bank"}
                                onChange={() => setReturnRefundType("bank")}
                              />
                              <div>
                                <div className="fw-bold small">Refund to Bank</div>
                                <div className="text-muted" style={{ fontSize: "11px" }}>
                                  Cash paid back to customer now
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`flex-fill p-3 rounded border-2 cursor-pointer ${
                              returnRefundType === "payable"
                                ? "border border-primary bg-primary bg-opacity-10"
                                : "border"
                            }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setReturnRefundType("payable")}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <input
                                type="radio"
                                checked={returnRefundType === "payable"}
                                onChange={() => setReturnRefundType("payable")}
                              />
                              <div>
                                <div className="fw-bold small">Keep as Customer Payable</div>
                                <div className="text-muted" style={{ fontSize: "11px" }}>
                                  Reduce on next sale or pay later
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Return Reason */}
                    <div className="mb-2">
                      <label className="fw-semibold mb-1 small">
                        Return Reason <span className="text-muted">(optional)</span>
                      </label>
                      <textarea
                        className="form-control form-control-sm"
                        rows={2}
                        placeholder="e.g. Damaged product, Wrong item..."
                        value={returnReason}
                        onChange={(e) => setReturnReason(e.target.value)}
                      />
                    </div>

                    {/* Return Invoice # */}
                    <div className="text-muted small">
                      Return Invoice#: <strong>{returnInvoiceNo}</strong>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="modal-footer border-0 pt-0">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowReturnModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger fw-bold"
                      onClick={handleProcessReturn}
                      disabled={fin.totalReturn === 0}
                    >
                      Confirm Return — ₹{fin.totalReturn.toFixed(2)}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}
        {/* ─────────────────────────────────────────────────────────── */}

        {/* Credit Payment Modal */}
        {pamentsModel && Paymentvalue && (
          <div
            className="modal fade show"
            style={{ display: pamentsModel ? "block" : "none", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content p-3 border-0 rounded-3xl shadow-xl">
                <div className="modal-header border-0">
                  <h5 className="modal-title fw-bold text-dark">Payment</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setpamentsModel(false)}
                  ></button>
                </div>
                <div className="modal-body text-start">
                  <div className="p-3 bg-light rounded mb-3 text-sm">
                    <p className="mb-2">
                      Sales ID: <span className="fw-bold">{Paymentvalue?.order_id}</span>
                    </p>
                    <p className="mb-2">
                      Customer Name: <span className="fw-bold">{Paymentvalue?.customer_name}</span>
                    </p>
                    <hr />
                    <div className="d-flex justify-content-between mb-2">
                      <span>Amount:</span>
                      <span className="text-primary fw-bold">₹{parseFloat(Paymentvalue?.overall_price).toFixed(2)}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span>Due Amount:</span>
                      <span className="text-danger fw-bold">₹{dueAmount.toFixed(2)}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Cash:</span>
                      <input
                        type="number"
                        className="form-control text-end w-25"
                        value={cashAmount}
                        onChange={handleCashChange}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Card:</span>
                      <input
                        type="number"
                        className="form-control text-end w-25"
                        value={cardAmount}
                        onChange={handleCardChange}
                      />
                    </div>
                    <hr />
                    <p className="mb-0 fw-bold fs-5 text-end">
                      Remaining Amount:{" "}
                      <span className="text-success fw-bold">₹{remainingAmount.toFixed(2)}</span>
                    </p>
                  </div>
                </div>
                <div className="modal-footer border-0 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => setpamentsModel(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-success"
                    disabled={totalPayment <= 0 || totalPayment > dueAmount}
                    onClick={() => onHandlePayCredit(cashAmount, cardAmount)}
                  >
                    Pay Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <OrderDetailsModal
          orders={selectedOrder}
          orderItems={orderItems}
          setSelectedOrder={setSelectedOrder}
          selectedOrder={selectedOrderData}
          isOpen={isOrderModal}
          onClose={() => setOrderModal(false)}
          handleGet={handleGet}
        />
      </div>
    </div>
  );
};

const OrderDetailsModal = ({
  orders,
  orderItems,
  isOpen,
  onClose,
  setSelectedOrder,
  handleGet,
  selectedOrder,
}) => {
  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      style={{ display: isOpen ? "block" : "none", backgroundColor: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div
          className="modal-content p-3 text-start"
          style={{
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Modal Header */}
          <div className="modal-header border-0">
            <h5 className="modal-title fw-bold text-dark font-18">Payment Details</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>

          {/* Modal Body */}
          <div className="modal-body pt-0">
            {selectedOrder && (
              <div className="mt-3">
                <table className="table table-bordered table-striped shadow-sm text-center">
                  <thead className="table-primary">
                    <tr>
                      <th colSpan="4">
                        <div className="justify-content-between d-flex">
                          <span>Order Details</span>
                          <a
                            className="bg-gradient-blues rounded px-2 font-13 text-black pointer"
                            onClick={() => {
                              onClose();
                              handleGet(selectedOrder);
                            }}
                          >
                            Invoice
                          </a>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fw-bold">Sales ID</td>
                      <td>{selectedOrder.order_id}</td>

                      <td className="fw-bold">Customer Name</td>
                      <td>{selectedOrder.customer_name}</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Date</td>
                      <td>{formatDate(selectedOrder.create_date || selectedOrder.date_time)}</td>

                      <td className="fw-bold">Total Amount</td>
                      <td>{selectedOrder.overall_price}</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Initial Amount</td>
                      <td>{selectedOrder.amount}</td>
                      <td className="fw-bold">Remaining Amount</td>
                      <td>{selectedOrder.remaining}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {/* Order Items */}
            <h6 className="modal-title fw-bold text-dark mt-3">Order Items</h6>
            <div className="table-responsive my-1 w-100">
              <table className="table table-sm table-bordered table-hover text-center">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {orderItems && orderItems.length > 0 ? (
                    orderItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="fw-semibold text-start">
                          {item.raw_material_title || `RM #${item.raw_mat_id}`}
                        </td>
                        <td>{item.qty}</td>
                        <td>
                          ₹
                          {item.is_free === "1"
                            ? "0.00"
                            : (parseFloat(item.p_price || 0) / parseFloat(item.qty || 1)).toFixed(2)}
                        </td>
                        <td className="fw-semibold">
                          {item.is_free === "1" ? (
                            <span className="text-success">Free</span>
                          ) : (
                            `₹${parseFloat(item.p_price || 0).toFixed(2)}`
                          )}
                        </td>
                        <td>
                          <span className={`badge ${item.is_free === "1" ? "bg-success" : "bg-primary"}`}>
                            {item.is_free === "1" ? "Offer" : "Normal"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center text-muted">
                        No items found
                      </td>
                    </tr>
                  )}
                </tbody>
                {orderItems && orderItems.length > 0 && (
                  <tfoot>
                    <tr>
                      <td colSpan="4" className="text-end fw-bold">
                        Grand Total:
                      </td>
                      <td className="fw-bold" colSpan={2}>
                        ₹
                        {orderItems
                          .filter((i) => i.is_free !== "1")
                          .reduce((sum, i) => sum + parseFloat(i.p_price || 0), 0)
                          .toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>

            {/* Payment History */}
            <h6 className="modal-title fw-bold text-dark mt-3">Payment History</h6>
            <div className="table-responsive text-center my-1 w-100 position-relative">
              <table className="table table-striped table-sm table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>MOP</th>
                    <th>Amount (INR)</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {orders
                    .filter((item) => item.mop != "2")
                    .map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{formatDate(item.date)}</td>
                        <td>{item.mop == "1" ? "Cash" : item.mop == "4" ? "Card" : ""}</td>
                        <td>{item.amount}</td>
                        <td>
                          <img
                            src="/assets/images/icons/view.png"
                            onClick={() => {
                              setSelectedOrder(
                                orders.filter((item) => item.mop != "2").slice(0, index + 1)
                              );
                              onClose();
                              handleGet(selectedOrder);
                            }}
                            height={"20px"}
                            alt="view"
                            className="me-2 pointer"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="modal-footer border-0 d-flex justify-content-end">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RMSalesList;
